var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loadingSummary || _vm.loadingTrend,
          expression: "loadingSummary || loadingTrend",
        },
      ],
      staticClass: "emp-attendance-stat-v3",
    },
    [
      _c("div", { staticClass: "stat-section-header" }, [
        _vm._m(0),
        _c("div", { staticClass: "header-badge-group" }, [
          _vm.hasSummary
            ? _c("span", { staticClass: "live-indicator" }, [
                _c("span", { staticClass: "pulse-dot" }),
                _vm._v(
                  " Đi làm: " +
                    _vm._s(_vm.employeeStats.present) +
                    "/" +
                    _vm._s(_vm.employeeStats.totalEmployees) +
                    " nhân sự (" +
                    _vm._s(_vm.formatRate(_vm.employeeStats.attendanceRate)) +
                    "%)\n      "
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm.apiError
        ? _c("el-alert", {
            staticClass: "stat-api-error",
            attrs: {
              title: _vm.apiError,
              type: "error",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _c("div", { staticClass: "emp-kpi-grid" }, [
        _c("div", { staticClass: "emp-kpi-card border-indigo" }, [
          _vm._m(1),
          _c("div", { staticClass: "kpi-details" }, [
            _c("span", { staticClass: "kpi-name" }, [
              _vm._v("Tổng số nhân sự"),
            ]),
            _c("div", { staticClass: "kpi-number text-indigo" }, [
              _vm._v(
                _vm._s(_vm.displayCount(_vm.employeeStats.totalEmployees)) + " "
              ),
              _c("span", { staticClass: "kpi-unit" }, [_vm._v("người")]),
            ]),
            _c("div", { staticClass: "kpi-hint" }, [_vm._v("Toàn bộ trường")]),
          ]),
        ]),
        _c("div", { staticClass: "emp-kpi-card border-emerald" }, [
          _vm._m(2),
          _c("div", { staticClass: "kpi-details" }, [
            _c("span", { staticClass: "kpi-name" }, [_vm._v("Đi làm")]),
            _c("div", { staticClass: "kpi-number text-emerald" }, [
              _vm._v(_vm._s(_vm.displayCount(_vm.employeeStats.present)) + " "),
              _c("span", { staticClass: "kpi-unit" }, [_vm._v("người")]),
            ]),
            _c("div", { staticClass: "kpi-hint text-emerald" }, [
              _c("i", { staticClass: "el-icon-check" }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.hasSummary
                      ? `${_vm.formatRate(
                          _vm.employeeStats.attendanceRate
                        )}% nhân sự`
                      : _vm.loadingSummary
                      ? "Đang tải số liệu"
                      : "Chưa có số liệu"
                  )
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "emp-kpi-card border-yellow" }, [
          _vm._m(3),
          _c("div", { staticClass: "kpi-details" }, [
            _c("span", { staticClass: "kpi-name" }, [_vm._v("Nghỉ có phép")]),
            _c("div", { staticClass: "kpi-number text-yellow" }, [
              _vm._v(
                _vm._s(_vm.displayCount(_vm.employeeStats.absentPermitted)) +
                  " "
              ),
              _c("span", { staticClass: "kpi-unit" }, [_vm._v("người")]),
            ]),
            _c("div", { staticClass: "kpi-hint" }, [
              _vm._v("Đã ghi nhận có phép"),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "emp-kpi-card border-rose" }, [
          _vm._m(4),
          _c("div", { staticClass: "kpi-details" }, [
            _c("span", { staticClass: "kpi-name" }, [
              _vm._v("Nghỉ không phép"),
            ]),
            _c("div", { staticClass: "kpi-number text-rose" }, [
              _vm._v(
                _vm._s(_vm.displayCount(_vm.employeeStats.absentUnpermitted)) +
                  " "
              ),
              _c("span", { staticClass: "kpi-unit" }, [_vm._v("người")]),
            ]),
            _c("div", { staticClass: "kpi-hint" }, [_vm._v("Chưa rõ lý do")]),
          ]),
        ]),
        _c("div", { staticClass: "emp-kpi-card border-amber" }, [
          _vm._m(5),
          _c("div", { staticClass: "kpi-details" }, [
            _c("span", { staticClass: "kpi-name" }, [_vm._v("Đi muộn")]),
            _c("div", { staticClass: "kpi-number text-amber" }, [
              _vm._v(
                _vm._s(_vm.displayCount(_vm.employeeStats.lateArrivals)) + " "
              ),
              _c("span", { staticClass: "kpi-unit" }, [_vm._v("người")]),
            ]),
            _c("div", { staticClass: "kpi-hint" }, [
              _vm._v("Theo giờ quy định của trường"),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "emp-kpi-card border-purple" }, [
          _vm._m(6),
          _c("div", { staticClass: "kpi-details" }, [
            _c("span", { staticClass: "kpi-name" }, [_vm._v("Về sớm")]),
            _c("div", { staticClass: "kpi-number text-purple" }, [
              _vm._v(
                _vm._s(_vm.displayCount(_vm.employeeStats.earlyDepartures)) +
                  " "
              ),
              _c("span", { staticClass: "kpi-unit" }, [_vm._v("người")]),
            ]),
            _c("div", { staticClass: "kpi-hint" }, [
              _vm._v("Trước giờ quy định"),
            ]),
          ]),
        ]),
      ]),
      _c(
        "el-row",
        { staticClass: "charts-row", attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { xs: 24, sm: 24, md: 9, lg: 8 } }, [
            _c("div", { staticClass: "chart-card h-100" }, [
              _c("div", { staticClass: "chart-card-head" }, [
                _c("div", [
                  _c("h3", { staticClass: "chart-title" }, [
                    _vm._v("Tỷ Lệ Đi Làm Hôm Nay"),
                  ]),
                  _c("p", { staticClass: "chart-subtitle" }, [
                    _vm._v(
                      "So với tổng số " +
                        _vm._s(
                          _vm.displayCount(_vm.employeeStats.totalEmployees)
                        ) +
                        " nhân sự đang làm"
                    ),
                  ]),
                ]),
                _c("span", { staticClass: "tag-pill tag-pill--emerald" }, [
                  _vm._v("Hôm nay"),
                ]),
              ]),
              _vm.hasSummary
                ? _c("div", {
                    ref: "chartEmpGauge",
                    staticClass: "chart-container",
                  })
                : _c("div", { staticClass: "chart-container chart-empty" }, [
                    _vm._v(
                      _vm._s(
                        _vm.loadingSummary
                          ? "Đang tải số liệu"
                          : "Chưa có số liệu"
                      )
                    ),
                  ]),
              _c("div", { staticClass: "gauge-footer-grid" }, [
                _c("div", { staticClass: "mini-stat-card" }, [
                  _c("span", { staticClass: "ms-label" }, [_vm._v("Đúng giờ")]),
                  _c("strong", { staticClass: "ms-val text-emerald" }, [
                    _vm._v(
                      _vm._s(_vm.displayCount(_vm.employeeStats.onTime)) +
                        " người"
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "mini-stat-card" }, [
                  _c("span", { staticClass: "ms-label" }, [_vm._v("Đi muộn")]),
                  _c("strong", { staticClass: "ms-val text-amber" }, [
                    _vm._v(
                      _vm._s(_vm.displayCount(_vm.employeeStats.lateArrivals)) +
                        " người"
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "mini-stat-card" }, [
                  _c("span", { staticClass: "ms-label" }, [_vm._v("Vắng mặt")]),
                  _c("strong", { staticClass: "ms-val text-rose" }, [
                    _vm._v(
                      _vm._s(_vm.displayCount(_vm.employeeStats.absentTotal)) +
                        " người"
                    ),
                  ]),
                ]),
              ]),
              _vm.hasSummary && _vm.employeeStats.unmarked > 0
                ? _c("p", { staticClass: "unmarked-note" }, [
                    _vm._v(
                      "Chưa chấm công: " +
                        _vm._s(_vm.employeeStats.unmarked) +
                        " người"
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("el-col", { attrs: { xs: 24, sm: 24, md: 15, lg: 16 } }, [
            _c("div", { staticClass: "chart-card h-100" }, [
              _c("div", { staticClass: "chart-card-head" }, [
                _c("div", [
                  _c("h3", { staticClass: "chart-title" }, [
                    _vm._v("Xu Hướng Chuyên Cần 7 Ngày Qua"),
                  ]),
                  _c("p", { staticClass: "chart-subtitle" }, [
                    _vm._v(
                      "Số người đi làm và tỷ lệ theo từng ngày trong 7 ngày gần nhất"
                    ),
                  ]),
                ]),
                _c("span", { staticClass: "tag-pill tag-pill--blue" }, [
                  _vm._v("7 ngày gần nhất"),
                ]),
              ]),
              _vm.hasTrend
                ? _c("div", {
                    ref: "chartEmpTrend",
                    staticClass: "chart-container",
                  })
                : _c("div", { staticClass: "chart-container chart-empty" }, [
                    _vm._v(
                      _vm._s(
                        _vm.loadingTrend
                          ? "Đang tải xu hướng"
                          : "Chưa có số liệu"
                      )
                    ),
                  ]),
              _c("div", { staticClass: "trend-legend-row" }, [
                _c("div", { staticClass: "legend-chip" }, [
                  _c("span", { staticClass: "chip-color chip-bar" }),
                  _c("span", [_vm._v("Đi làm (người)")]),
                ]),
                _c("div", { staticClass: "legend-chip" }, [
                  _c("span", { staticClass: "chip-color chip-bg" }),
                  _c("span", [_vm._v("Tổng nhân sự (người)")]),
                ]),
                _c("div", { staticClass: "legend-chip" }, [
                  _c("span", { staticClass: "chip-color chip-line" }),
                  _c("span", [_vm._v("Tỷ lệ đi làm (%)")]),
                ]),
                _c("div", { staticClass: "legend-chip" }, [
                  _c("span", { staticClass: "chip-color chip-late" }),
                  _c("span", [_vm._v("Đi muộn (người)")]),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-title-group" }, [
      _c("div", { staticClass: "header-icon-badge" }, [
        _c("i", { staticClass: "el-icon-s-cooperation" }),
      ]),
      _c("div", [
        _c("h2", { staticClass: "header-title" }, [
          _vm._v("Thống Kê Chuyên Cần & Chấm Công Nhân Sự"),
        ]),
        _c("p", { staticClass: "header-subtitle" }, [
          _vm._v(
            "Theo dõi tình hình điểm danh đi làm, nghỉ phép, đi muộn và về sớm của cán bộ - giáo viên - nhân viên"
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-indigo-soft text-indigo" },
      [_c("i", { staticClass: "el-icon-user" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-emerald-soft text-emerald" },
      [_c("i", { staticClass: "el-icon-circle-check" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-yellow-soft text-yellow" },
      [_c("i", { staticClass: "el-icon-warning-outline" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "kpi-icon-wrap bg-rose-soft text-rose" }, [
      _c("i", { staticClass: "el-icon-circle-close" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-amber-soft text-amber" },
      [_c("i", { staticClass: "el-icon-time" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-purple-soft text-purple" },
      [_c("i", { staticClass: "el-icon-right" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }